module.exports = __webpack_public_path__ + "img/BirdFriendlyLogoBlack.4a7c1844.svg";